import { useEffect, useState } from "react";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { PRIORITY_DATA } from "../../utils/data";
import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import { useNavigate, useLocation } from "react-router-dom";
import { LuTrash2 } from "react-icons/lu";
import moment from "moment";
import "moment/locale/fr";
import SelectDropdown from "../../components/Inputs/SelectDropdown";
import SelectUsers from "../../components/Inputs/SelectUsers";
import AddAttachementsInput from "../../components/Inputs/AddAttachementsInput";
import TodoListInput from "../../components/Inputs/TodoListInput";
import Modal from "../../components/Modal";
import DeleteAlert from "../../components/DeleteAlert ";
moment.locale("fr");
const CreateTask = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { taskId } = location.state || {};
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [taskData, setTaskData] = useState({
    title: "",
    description: "",
    priority: "faible",
    dueDate: "",
    assignedTo: [],
    todoCheckList: [],
    attachments: [],
  });

  const [currentTask, setCurrentTask] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const handleValueChange = (key, value) => {
    setTaskData((prevData) => ({ ...prevData, [key]: value }));
  };

  const clearData = () => {
    // Réinitialiser les données du formulaire
    setTaskData({
      title: "",
      description: "",
      priority: "faible",
      dueDate: null,
      assignedTo: [],
      todoCheckList: [],
      attachments: [],
    });
  };

  //creation de tache
  const createTask = async () => {
    setLoading(true);
    try {
      // const todolist = taskData.todoCheckList?.map((item) => ({
      //   text: item,
      //   completed: false,
      // }));
      const todolist = taskData.todoCheckList?.map((item) => ({
        text: typeof item.text === "string" ? item.text : item.text.text || "",
        completed: !!item.completed,
      }));

      const response = await axiosInstance.post(API_PATHS.TASKS.CREATE_TASK, {
        ...taskData,
        dueDate: new Date(taskData.dueDate.toString()),
        todoCheckList: todolist,
        projectId: selectedProject,
      });
      console.log("Tâche créée avec succès :", response.data);
      toast.success("Tâche créée avec succès");
      clearData();
    } catch (error) {
      console.error("Erreur lors de la création de la tâche :", error);
      toast.error("Échec de la création de la tâche");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    //  Validation des champs
    if (!taskData.title.trim()) {
      setError("Le nom de la tâche est obligatoire");
      return;
    }

    if (!taskData.description.trim()) {
      setError("La description de la tâche est obligatoire");
      return;
    }

    if (!taskData.dueDate) {
      setError("La date d'échéance est obligatoire");
      return;
    }

    if (!taskData.assignedTo || taskData.assignedTo.length === 0) {
      setError("Au moins un membre doit être assigné à la tâche");
      return;
    }

    if (!taskData.todoCheckList || taskData.todoCheckList.length === 0) {
      setError("La liste de contrôle ne peut pas être vide");
      return;
    }

    //  Création ou mise à jour
    try {
      if (taskId) {
        await updateTask();
        console.log("taskId update:", taskId);
      } else {
        await createTask();
      }
    } catch (error) {
      setError("Une erreur est survenue lors de l'enregistrement");
    }
  };

  // suppression d'une tache
  const deleteTask = async () => {
    try {
      await axiosInstance.delete(API_PATHS.TASKS.DELETE_TASK(taskId));
      setOpenDeleteAlert(false);
      toast.success("suppression de tache reussi");
      clearData();
      navigate("/admin/tasks");
    } catch (error) {
      console.error("echec de suppression de tache", error);
    }
  };
  // mise a jour d'une tache
  // recuperation d'une tache par id
  const getTaskDetailByID = async (taskId) => {
    try {
      const response = await axiosInstance.get(
        API_PATHS.TASKS.GET_BY_ID(taskId),
      );
      if (response.data) {
        const taskInfo = response.data;
        console.log(taskInfo);

        setCurrentTask(taskInfo);
        setTaskData((prevState) => ({
          title: taskInfo.title,
          description: taskInfo.description,
          priority: taskInfo.priority,
          dueDate: taskInfo.dueDate
            ? moment(taskInfo.dueDate).format("YYYY-MM-DD")
            : null,
          assignedTo: taskInfo?.assignedTo?.map((item) => item?._id || []),
          todoCheckList: taskInfo?.todoCheckList || [],
          attachments: taskInfo?.attachments || [],
        }));
      }
    } catch (error) {
      console.error("erreur de recuperation de l'utilisateur", error);
    }
  };

  useEffect(() => {
    if (taskId) {
      getTaskDetailByID(taskId);
    }
  }, [taskId]);
  //chargement des projets
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axiosInstance.get(
        API_PATHS.PROJECT.GET_ALL_PROJECT
      );
      setProjects(response.data);
    } catch (error) {
      console.error("Erreur fetchProjects:", error);
    }
  };
  // mise a jour d'une tache
  //   setLoading(true);
  //   try {
  //     const todolist = taskData.todoChecklist?.map((item) => {
  //       const prevTodoChecklist = currentTask?.todoChecklist || [];
  //       const matchedTask = prevTodoChecklist.find((task) => task.text == item);
  //       return {
  //           task: item,
  //         completed: matchedTask ? matchedTask.completed : false,
  //       };
  //     });
  //     const response = axiosInstance.put(API_PATHS.TASKS.UPDATE_TASK(taskId), {
  //       ...taskData,
  //       dueDate: new Date(taskData.dueDate).toString(),
  //       todoChecklist: todolist,
  //     });
  //     toast.success("Tache mis a jour avec success ");
  //   } catch (error) {
  //     console.error("echec lors de la mise a jour de la tache", error);
  //     toast.error("echec de mise a jour de la tache");
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const updateTask = async () => {
    setLoading(true);
    try {
      // Ancienne todoChecklist (avant modif)
      const prevTodoChecklist = currentTask?.todoCheckList || [];

      // Nouvelle todoChecklist venant du formulaire
      const todolist = taskData.todoCheckList?.map((item) => {
        // item est déjà un objet { text, completed }
        const matchedTask = prevTodoChecklist.find((t) => t.text === item.text);
        return {
          text: item.text,
          completed: matchedTask ? matchedTask.completed : false, // conserve l'état précédent
        };
      });

      const response = await axiosInstance.put(
        API_PATHS.TASKS.UPDATE_TASK(taskId),
        {
          ...taskData,
          dueDate: new Date(taskData.dueDate).toISOString(),
          todoCheckList: todolist,
          projectId: selectedProject,
        }
      );

      toast.success("Tâche mise à jour avec succès !");
      clearData();
    } catch (error) {
      console.error("Échec lors de la mise à jour de la tâche", error);
      toast.error("Échec de mise à jour de la tâche");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout activeMenu="Taches">
      <div className="mt-5">
        <div className="grid grid-cols-1 md: grid-cols-2 mt-4">
          <div className="form-card col-span-3">
            <div className="flex items-center justify-between ">
              <h2 className="text-xl md:text-xl font-medium">
                {taskId ? "modifier" : "creer une tache"}
              </h2>
              {taskId && (
                <button
                  onClick={() => setOpenDeleteAlert(true)}
                  className="flex items-center gap-1.5 text-[13px] font-medium text-rose-500 bg-rose rounded px-2 py-1 border border-rose-100 hover:border-rose-300 cursor-pointer "
                >
                  <LuTrash2 className="text-base" />
                  Effacer
                </button>
              )}
            </div>
            <div className="mt-4 ">
              <label
                name="title"
                className="text-xs font-medium text-slate-600"
              >
                Nom de la tache
              </label>
              <input
                type="text"
                htmlFor="title"
                placeholder="Entrer le nom de la tache"
                value={taskData.title}
                className="form-input"
                onChange={(e) => handleValueChange("title", e.target.value)}
              />
            </div>

            <div className="mt-3 ">
              <label
                name="description"
                className="text-xs font-medium text-slate-600"
              >
                Description
              </label>
              <textarea
                htmlFor="description"
                placeholder="decrire la tache"
                rows={4}
                value={taskData.description}
                className="form-input"
                onChange={(e) =>
                  handleValueChange("description", e.target.value)
                }
              />
            </div>
            <div className="grid grid-cols-12 gap-4 mt-2">
              <div className="col-span-6 md:col-span-4">
                <label className="text-xs font-medium text-slate-600">
                  Priorité
                </label>
                <SelectDropdown
                  options={PRIORITY_DATA}
                  value={taskData.priority}
                  onChange={(value) => handleValueChange("priority", value)}
                  placeholder="Selectionner la priorité"
                />
              </div>
              <div className="col-span-6 md:col-span-4">
                <label
                  htmlFor=""
                  className="text-xs font-medium text-slate-600"
                >
                  Date d'échéance
                </label>
                <input
                  placeholder="Sélectionner la date d'échéance"
                  className="form-input"
                  type="date"
                  value={
                    taskData.dueDate
                      ? moment(taskData.dueDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => handleValueChange("dueDate", e.target.value)}
                />
              </div>

              <div className="col-span-12 md:col-span-4 ">
                <label className="text-xs font-medium text-slate-600">
                  Membres assignés
                </label>
                <SelectUsers
                  selectedUsers={taskData.assignedTo}
                  setSelectedUsers={(users) =>
                    handleValueChange("assignedTo", users)
                  }
                />
              </div>
            </div>
            <div className="mt-3">
              <label className="text-xs font-medium text-slate-600">
                Liste de contrôle
              </label>
              <TodoListInput
                todoList={taskData?.todoCheckList || []}
                setTodoList={(value) =>
                  handleValueChange("todoCheckList", value)
                }
              />
            </div>
            <div className="mt-3">
              <label className="text-xs font-medium text-slate-600">
                Ajouter des pièces jointes{" "}
              </label>
              <AddAttachementsInput
                attachments={taskData.attachments}
                setAttachments={(value) =>
                  handleValueChange("attachments", value)
                }
              />
            </div>
            <select
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.target.value)}
              className="form-input"
            >
              <option value="">
                <span className="text-xs font-medium text-slate-600">
                  Sélectionnez un projet
                </span>
              </option>
              {projects.map((project) => (
                <option key={project._id} value={project._id}>
                  {project.name}
                </option>
              ))}
            </select>
            {
              /* Affichage des erreurs */
              error && (
                <p className="text-xs text-red-500 mt-5 font-medium">{error}</p>
              )
            }
            <div className="flex justify-end mt-7">
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="btn-primary disabled:opacity-50 mt-4"
              >
                {taskId ? "Mettre à jour la tache" : "Créer la tache"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={openDeleteAlert}
        onClose={() => setOpenDeleteAlert(false)}
        title="supprimer une tache"
      >
        <DeleteAlert
          content="etes vous sur de vouloir supprimer la tache ?"
          onDelete={() => deleteTask()}
        />
      </Modal>
    </DashboardLayout>
  );
};

export default CreateTask;
